import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { ControllerFormTextInput } from '@src/orders/PermitFormSections/ControllerFormTextInput';
import { FormDatePicker } from '@src/orders/PermitFormSections/FormDatePicker';
import { FormDateTimePicker } from '@src/orders/PermitFormSections/FormDateTimePicker';
import type { CompletePermitSchemaType } from '@src/permits/completePermit/fields/CompletePermitFields';
import {
  ExpirationDateField,
  StatePermitNumberField,
} from '@src/permits/completePermit/fields/CompletePermitFields';
import { EffectiveDateField } from '@src/permits/completePermit/fields/CompletePermitFields';
import type { Control } from 'react-hook-form';

interface Props {
  control: Control<CompletePermitSchemaType>;
  readOnly?: boolean;
  validateExpirationTime: boolean;
  validateExpirationDate: boolean;
}

export const StatePermitInfo = ({
  control,
  readOnly,
  validateExpirationDate,
  validateExpirationTime,
}: Props) => {
  return (
    <Stack gap={theme.spacing['3']}>
      <Stack direction="row" gap={theme.spacing['3']}>
        <FormDateTimePicker
          control={control}
          fieldName={EffectiveDateField.fieldName}
          readOnly={readOnly}
          isUTC
        />
        {validateExpirationTime && (
          <FormDateTimePicker
            control={control}
            fieldName={ExpirationDateField.fieldName}
            readOnly={readOnly}
            isUTC
          />
        )}
        {!validateExpirationTime && validateExpirationDate && (
          <FormDatePicker
            control={control}
            fieldName={ExpirationDateField.fieldName}
            readOnly={readOnly}
            isUTC
          />
        )}
      </Stack>
      <ControllerFormTextInput
        control={control}
        fieldName={StatePermitNumberField.fieldName}
        readOnly={readOnly}
      />
    </Stack>
  );
};
